.c-loading-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 75%);

  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  opacity: 0;
  visibility: hidden;
  transition: opacity 200ms ease-in;

  &.is-visible {
    opacity: 1;
    visibility: visible;
    transition: opacity 200ms ease-out;
  }
}
